export default __webpack_public_path__ + "static/media/IMG_0053.d6c751de.jpg";